import { Col, Modal, Row } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useState } from "react";
import "./TimesheetReasonModal.css";
import { LoadingOutlined } from "@ant-design/icons";
const TimesheetReasonModal = ({
  open,
  title = "Reject Timesheet",
  handleCancel,
  handleSubmit,
  loading,
}) => {
  const [reason, setReason] = useState("");
  return (
    <Modal
      closable={true}
      title={title}
      footer={
        <Row>
          <button
            className="reason-modal-submit-button"
            disabled={loading}
            onClick={() => {handleSubmit(reason) ; handleCancel()}}
          >
            Submit {loading ? <LoadingOutlined /> : ""}
          </button>
        </Row>
      }
      open={open}
      onCancel={handleCancel}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(reason);
        }}
      >
        <Row>
          <Col span={24}>
            <Row>
              <p className="reason-modal-first-heading">Reason</p>
            </Row>
            <Row>
              <TextArea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                maxLength={50}
                showCount
                style={{ height: 100, resize: "none", width: "100%" }}
              />
            </Row>
            <button
              disabled={loading}
              type="submit"
              style={{ display: "none" }}
            ></button>
          </Col>
        </Row>
      </form>
    </Modal>
  );
};

export { TimesheetReasonModal };
